
import { Component, Vue, Prop } from "vue-property-decorator";
import DateTimeMixin from "@/mixins/datetime";
import { i18n } from "@/i18n";
import { Transaction } from "@/entities";
import { PCol, PFormSelectNarrow, PRow } from "@/common/components";
import LogicCashTodayDetailLastTransactions from "@/pages/logic-cash-today-detail/components/LogicCashTodayDetailLastTransactions.vue";

@Component({
  mixins: [DateTimeMixin],
  components: {
    LogicCashTodayDetailLastTransactions,
    PRow,
    PCol,
    PFormSelectNarrow,
  },
})
export class DetailTransaction extends Vue {
  @Prop({ required: true }) value!: boolean;
  @Prop({ required: true, default: {} }) transaction!: Transaction;

  language = i18n.locale;
  options = [
    { text: this.$t("transactions.filter.showAllFields"), value: "showAllFields" },
    { text: this.$t("transactions.filter.dontShowAllFields"), value: "dontShowAllFields" },
  ];
  valueSelect = "";
  origin = this.$t("transactions.transactionOrigin.DECLARED");
  destroyed(): void {
    this.$emit("input", !this.value);
  }
  created() {
    this.getOrigin();
  }
  //TODO this logic should be on the backend
  getOrigin(): void {
    const boxNameRaw = this.transaction?.denominations[0]?.boxNameRaw;
    this.origin = boxNameRaw ? this.$t(`transactions.transactionOrigin.${boxNameRaw}`) : "";
  }
}
export default DetailTransaction;
